module.exports = __webpack_public_path__ + "static/media/intro_icon_5.541b9f09.svg";